// apiService.js
import { API_PASSWORD } from './config';
import { getSubdomain, fetchWithAuth } from './helpers';


////////////////SETUP////////////////////////////

export const loginUser = async (username, password, root_id) => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ لا يمكن العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/system/login?api_password=Project102$_`;

  const formData = new FormData();
  formData.append("username", username);
  formData.append("password", password);
  formData.append("root_id", root_id);

  const response = await fetch(apiUrl, { method: "POST", body: formData });
  const data = await response.json();

  if (response.ok && data?.data?.token) {
    return data; // 👈 لا تحفظ في localStorage هنا
  } else {
    const errorMessage = data.message || "❌ بيانات تسجيل الدخول غير صحيحة.";
    throw new Error(errorMessage);
  }
};

export const fetchAuthRoots = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/roots/data/auth?api_password=Project102$_`;

  console.log("📌 إرسال طلب لجلب الفروع المصرح بها:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("❌ فشل في جلب الفروع:", errorText);
    throw new Error("❌ فشل في جلب الفروع.");
  }

  const result = await response.json();
  console.log("✅ الفروع المستلمة:", result);

  return result?.data?.data || [];
};



export const logoutUser = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ لا يمكن العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/system/logout?api_password=Project102$_`;

  const token = localStorage.getItem("token");
  
  if (!token) {
    console.error("❌ لا يوجد توكن صالح لتسجيل الخروج.");
    return;
  }

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`, // إرسال التوكن في الهيدر
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تسجيل الخروج.");
  }

  // مسح بيانات المستخدم والتوكن من localStorage
  localStorage.removeItem("token");
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("user");

  console.log("✅ تم تسجيل الخروج بنجاح.");
  
  return data;
};




// حفظ البيانات العامة
export const saveGeneralInfo = async (formData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/save/public/data`;

  const formDataToSend = new FormData();
  formDataToSend.append("api_password", API_PASSWORD);
  formDataToSend.append("name", formData.name || "مطعمي الافتراضي");
  formDataToSend.append("main_mood", formData.main_mood || "light");

  if (formData.logo) {
    formDataToSend.append("logo", formData.logo);
  }

  // --- New fields to include ---
  if (formData.footer_image) {
    formDataToSend.append("footer_image", formData.footer_image);
  }
  if (formData.banner_image) {
    formDataToSend.append("banner_image", formData.banner_image);
  }
  if (formData.invoice_note_printer) {
    formDataToSend.append("invoice_note_printer", formData.invoice_note_printer);
  }
  if (formData.address) {
    formDataToSend.append("address", formData.address);
  }
  if (formData.phone) {
    formDataToSend.append("phone", formData.phone);
  }
  // --- end new fields ---

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formDataToSend,
  }, true);

  if (!response.ok) throw new Error("❌  برجاء التاكد من جميع البياتات ومن اللوجو");

  return response.json();
};



// إنشاء فرع
export const createMainRoot = async (name, address) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/main/root`;

  const formData = new FormData();
  formData.append("name", name);
  formData.append("address", address);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  const data = await response.json();

  if (!response.ok) {
    const errorMessage = data.message || "❌ فشل في إنشاء الفرع الرئيسي.";
    throw new Error(errorMessage);
  }

  return data;
};



// إنشاء الخزنة (البنك)
export const createBank = async (name, discount_percentage) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/main/bank`;

  const formData = new FormData();
  formData.append("name", name);
  formData.append("discount_percentage", discount_percentage);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  if (!response.ok) throw new Error("❌ فشل في إنشاء البنك.");

  return response.json();
};



export const createTables = async (number) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/first/table?number=${number}`;

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
  });

  const data = await response.json();

  if (!response.ok) {
    const errorMessage = data.message || "❌ فشل في إنشاء الطاولات.";
    throw new Error(errorMessage);
  }

  return data;
};




// إنشاء مطبخ
export const createKitchen = async (name) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/first/kitchen`;

  const formData = new FormData();
  formData.append("name", name);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true);

  if (!response.ok) throw new Error("❌ فشل في إنشاء المطبخ.");

  return response.json();
};


// تخيطي الكل 
export const autoSetup = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ لا يمكن العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/auto/setup`;

  const response = await fetchWithAuth(apiUrl, {
    method: "GET",
  }, false, true); // ✅ أرسل التوكن هنا true

  const data = await response.json();
  
  console.log("🔍 Auto Setup API full response:", data);

  if (!response.ok) {
    throw new Error(data.message || "❌ حدث خطأ أثناء عملية الإعداد التلقائي.");
  }

  return data;
};



export const fetchProfileCompletion = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/profile/completation?api_password=${API_PASSWORD}`;

  console.log("📌 إرسال طلب لجلب البيانات المصرح بها:", apiUrl);

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("❌ فشل في جلب البيانات:", errorText);
    throw new Error("❌ فشل في جلب البيانات.");
  }

  const result = await response.json();
  console.log("✅ البيانات المستلمة:", result);

  return result?.data || [];
};

// ------------------------------------------------------------------
// New: جلب مميزات خطة النظام (system planes features)
export const getSystemPlanFeatures = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("❌ لا يوجد توكن مخزّن، يجب تسجيل الدخول.");
  }

  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ لا يمكن العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/get/system/planes/features?api_password=${API_PASSWORD}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
  });

  if (!response.ok) {
    const text = await response.text();
    console.error("❌ فشل في جلب مميزات الخطة:", text);

    // 👈 معالجة انتهاء صلاحية التوكن
    if (response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login"; // إعادة التوجيه
    }

    throw new Error("❌ فشل في جلب مميزات الخطة.");
  }

  return await response.json();
};
